import { keyframes } from '@emotion/react';
import styled from '@emotion/styled';
import { Box } from '~Styles';

export const pulseAnimation = keyframes`
  0% { opacity: 0.6; }
  50% { opacity: 0.3; }
  100% { opacity: 0.6; }
`;

export const BlurryBox = styled.div<{ width?: string; height?: string }>`
  width: ${({ width }) => (width ? width : '100px')};
  height: ${({ height }) => (height ? height : '16px')};
  background-color: var(--colorBlueGray200);
  border-radius: 4px;
  animation: ${pulseAnimation} 2s ease-in-out infinite;
`;

export const SkeletonItem = styled(Box)<{ opacity?: number }>`
  background: var(--colorBlueGray1100);
  overflow: hidden;
  border-bottom: 1px solid var(--colorBlueGray1000);
  padding: 12px 16px;
  width: 100%;
  box-sizing: border-box;
  opacity: ${({ opacity }) => (opacity ? opacity : 1)};

  &:nth-child(2) {
    border-top-right-radius: 8px;
    border-top-left-radius: 8px;
  }

  &:last-child {
    border-bottom-right-radius: 8px;
    border-bottom-left-radius: 8px;
    border-bottom: none;
  }
`;

export const ButtonsWrapper = styled.div`
  margin-top: 16px;
  display: flex;
  flex-flow: row wrap;
  gap: 8px;

  button {
    flex: 1;
    font-size: 11px;
    flex-direction: column;
    padding: 8px 4px;

    span {
      margin-left: 0;
      margin-top: 4px;
    }
  }
`;

export const RefundedInfoBox = styled.div`
  background: var(--colorUIRed);
  padding: 8px;
  border-radius: 4px;
  margin-bottom: 8px;
  color: var(--colorWhite);
  font-size: 14px;
  text-align: center;
  margin-top: 16px;
`;
